import { Observable, of } from 'rxjs';

import { TranslateLoader } from '@ngx-translate/core';

export class JsonModuleLoaderService implements TranslateLoader {
  TRANSLATIONS: {
    ar: any;
    en: any;
  };
  constructor(TRANSLATIONS: any) {
    this.TRANSLATIONS = TRANSLATIONS;
  }
  getTranslation(lang: string): Observable<any> {
    return of(this.TRANSLATIONS[lang]);
  }
}
